<script lang="ts">
  import { getConversationEventAttachmentURL } from "../../../lib";

  export let s;
  export let marginTop;
  export let url;
</script>

<div class={s.flexEnd} style={`margin-top: ${marginTop}`}>
  <img class={s.attachmentImage} src={getConversationEventAttachmentURL(url)} alt="Attachment" />
</div>
